import axios from "axios";
import routes from "../../configs/api";

const phoneOtpWithGoogle = (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.SEND_PHONE_OTP_WITH_GOOGLE;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default phoneOtpWithGoogle;
